if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.querySelector('[data-carousel-previous]').addEventListener('click', () => this.move(-1));
      this.querySelector('[data-carousel-next]').addEventListener('click', () => this.move(1));
      this.addEventListener('keydown', (event) => {
        if (!this.hasAttribute('open') || event.target.closest('input, textarea, select, video, iframe, model-viewer')) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
      const content = this.querySelector('[role="document"]');
      content.addEventListener('touchstart', (event) => {
        this.swipeStart = event.touches.length === 1 && event.target.tagName === 'IMG'
          ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
      }, { passive: true });
      content.addEventListener('touchmove', (event) => {
        if (event.touches.length !== 1) this.swipeStart = null;
      }, { passive: true });
      content.addEventListener('touchcancel', () => { this.swipeStart = null; });
      content.addEventListener('touchend', (event) => {
        const start = this.swipeStart;
        this.swipeStart = null;
        if (!start || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - start.x;
        const dy = event.changedTouches[0].clientY - start.y;
        if (Math.abs(dx) >= 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.move(dx < 0 ? 1 : -1);
      }, { passive: true });
    }

    get slides() {
      return Array.from(this.querySelector('[role="document"]').children).filter(element => element.hasAttribute('data-media-id'));
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const index = this.slides.findIndex(element => element.dataset.mediaId === this.openedBy.dataset.mediaId);
      this.selectSlide(index < 0 ? 0 : index);
    }

    move(direction) {
      const total = this.slides.length;
      if (total > 1) this.selectSlide((this.currentIndex + direction + total) % total);
    }

    selectSlide(index) {
      const slides = this.slides;
      if (!slides.length) return;
      window.pauseAllMedia();
      this.currentIndex = index;
      slides.forEach((element, position) => {
        element.classList.toggle('active', position === index);
        element.hidden = position !== index;
        element.setAttribute('aria-hidden', position === index ? 'false' : 'true');
      });
      const active = slides[index];
      if (active.tagName === 'IMG') active.loading = 'eager';
      const template = active.querySelector('template');
      if (active.nodeName === 'DEFERRED-MEDIA' && template?.content.querySelector('.js-youtube')) active.loadContent();
      const counter = this.querySelector('[data-carousel-counter]');
      counter.textContent = `${index + 1} ${counter.dataset.of} ${slides.length}`;
      this.querySelectorAll('[data-carousel-previous], [data-carousel-next]').forEach(button => { button.disabled = slides.length < 2; });
    }

    hide() {
      this.swipeStart = null;
      super.hide();
    }
  });
}
